import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
const logoDefensoria = '/img/logo_branco.png';

export default function InscricaoConfirmacaoPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState<string>('');
  const [urlBoleto, setUrlBoleto] = useState<string>('');

  useEffect(() => {
    // Pegar parâmetros da query string
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    const cpfParam = params.get('cpf');
    const nomeParam = params.get('nome');

    if (emailParam) {
      setEmail(emailParam);
    }

    // Gerar URL do boleto se tiver CPF e nome
    if (cpfParam && nomeParam) {
      const cpfBoleto = cpfParam.replace(/\D/g, ''); // Garantir que está sem formatação
      const nomeBoleto = encodeURIComponent(nomeParam);
      const url = `https://security.sefaz.se.gov.br/internet/publico/process.jsp?AppName=SAE&TransId=T28825&CPF=${cpfBoleto}&nmPessoa=${nomeBoleto}&Receita=151`;
      setUrlBoleto(url);
    }
  }, [location]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body text-center p-5">
              <img style={{ width: '150px', height: '150px' }} src={logoDefensoria} alt="Logo Defensoria" className="img-fluid mb-4" />
              <div className="mb-4">
                <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
              </div>
              <h2 className="card-title mb-4">Inscrição Realizada com Sucesso!</h2>

              <div className="alert alert-info mb-4">
                <h5 className="alert-heading">
                  <i className="bi bi-envelope-check me-2"></i>
                  Verifique seu email
                </h5>
                <p className="mb-2">
                  Enviamos um email de confirmação para:
                </p>
                {email && (
                  <p className="mb-0">
                    <strong>{email}</strong>
                  </p>
                )}
                {!email && (
                  <p className="mb-0">
                    <strong>o email informado no formulário</strong>
                  </p>
                )}
              </div>

              <div className="mb-4">
                <p className="text-muted">
                  No email você encontrará:
                </p>
                <ul className="list-unstyled text-start mb-4">
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Confirmação da sua inscrição
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Link para acompanhar seus processos seletivos
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Informações sobre o status da sua candidatura
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Link para gerar o boleto de pagamento
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Passo a passo para desbloqueio de pop-up
                  </li>
                </ul>
              </div>

              <div className="alert alert-secondary mb-4">
                <h5 className="alert-heading">
                  <i className="bi bi-window-stack me-2"></i>
                  Desbloqueio de pop-up
                </h5>
                <p className="mb-3">
                  Se o navegador bloquear janelas ou links (pop-ups), acesse o link abaixo e siga o passo a passo para liberar o acesso ao portal e à geração do boleto:
                </p>
                <a
                  href="https://www.defensoria.se.def.br/inscricao/passo-a-passo-pop-up.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary"
                >
                  <i className="bi bi-file-earmark-pdf me-2"></i>
                  Passo a passo para desbloqueio de pop-up (PDF)
                </a>
              </div>

              {urlBoleto && (
                <div className="alert alert-success mb-4">
                  <h5 className="alert-heading">
                    <i className="bi bi-receipt me-2"></i>
                    Gerar Boleto de Pagamento
                  </h5>
                  <p className="mb-3">
                    Clique no botão abaixo para gerar seu boleto de pagamento:
                  </p>
                  <a
                    href={urlBoleto}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-lg"
                  >
                    <i className="bi bi-receipt me-2"></i>
                    Gerar Boleto de Pagamento
                  </a>
                </div>
              )}

              <div className="alert alert-warning mb-4">
                <small>
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Não recebeu o email?</strong> Verifique sua caixa de spam ou lixo eletrônico.
                  O email pode levar alguns minutos para chegar.
                </small>
              </div>

              <div className="d-grid gap-2">
                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/candidato/login')}
                >
                  Acessar Portal do Candidato
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

